import styled from 'styled-components';

const NewBadge = styled.span`
    font-family: ${({ theme }) => theme.style_primary};
    font-style: normal;
    font-weight: ${({ theme }) => theme.fontBold};
    font-size: 0.625em;
    color: ${({ theme }) => theme.gray_7};
    text-transform: uppercase;
    background-color: ${({ theme, $bgColor }) => $bgColor || theme.green_1};
    border-radius: ${({ theme }) => theme.space_16}px;
    padding: 0.1em 0.5em;
    margin-left: 0.5em;
`;

export default NewBadge;
